document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('form.contact__form');

  console.log("Contact form found:", form);

  if (!form) return;

  form.addEventListener("submit", function () {
    console.log("Form submitted — triggering webhook");
    // Use a slight delay to ensure the form is processed by Shopify first
    setTimeout(() => {
      const yourName = document.getElementById("your-name")?.value || "";
      const email = document.getElementById("email")?.value || "";
      const location = document.getElementById("location")?.value || "";
      const budget = document.getElementById("budget")?.value || "";
      const reference = document.getElementById("{{ form_id }}-reference")?.value || "";
      const inquiryDetails = document.getElementById("inquiry-details")?.value || "";

      const formData = {
        yourName: yourName,
        email: email,
        location: location,
        budget: budget,
        styleReference: reference,
        inquiryDetails: inquiryDetails
      };

      fetch("https://script.google.com/macros/s/AKfycbwRWvPgAFfSRDRWBljUmJlGK76rE9ehIqu9-0BrctrEgl89vIxfCP_YuRIdXxPwYT-y/exec", {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData)
      });

    }, 300); // Adjust if needed
  });
});
